// @flow
import { Component, type Node } from 'react';
import AExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';
import PropTypes from 'prop-types';

type Props = {
  children: Node,
  experiments: AExperimentsClient,
  seoExperiments: AExperimentsClient,
  seoUnauthExperiments: AExperimentsClient,
};

export default class ExperimentsProvider extends Component<Props> {
  getChildContext() {
    const { experiments, seoExperiments, seoUnauthExperiments } = this.props;
    return {
      experiments,
      seoExperiments,
      seoUnauthExperiments,
      serverRenderComplete: this.serverRenderComplete,
    };
  }

  componentDidMount() {
    this.serverRenderComplete = true;
  }
  serverRenderComplete = false;

  render() {
    return this.props.children;
  }
}
ExperimentsProvider.childContextTypes = {
  experiments: PropTypes.instanceOf(AExperimentsClient).isRequired,
  seoExperiments: PropTypes.instanceOf(AExperimentsClient).isRequired,
  seoUnauthExperiments: PropTypes.instanceOf(AExperimentsClient).isRequired,
  serverRenderComplete: PropTypes.bool.isRequired,
};
ExperimentsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  experiments: PropTypes.instanceOf(AExperimentsClient).isRequired,
  seoExperiments: PropTypes.instanceOf(AExperimentsClient).isRequired,
  seoUnauthExperiments: PropTypes.instanceOf(AExperimentsClient).isRequired,
};
